import React, { useEffect, useState } from "react";
import { Container, Col } from "react-bootstrap";
import RestaurantCard from "./Component/Restaurantcards";
import RestaurantShopdata from "./Component/Restaurant_Shopdata";
import "./style.css";
import { useParams } from "react-router-dom";
import {
  useGetShopByIdQuery,
  useGetUserShopsByBusinessTypeQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";
import { extractIdFromSlug } from "../../utils/slugUtils";

const RestaurantAlldata = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const [shopData, setShopData] = useState();
  const [suggestdata, setSuggestdata] = useState();
  const [suggest, setSuggest] = useState(0);
  const { name } = useSelector((state) => state.user);

  const { data: userShopsData } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "foodShop" },
    { skip: !name?._id },
  );

  useEffect(() => {
    if (userShopsData?.success) {
      const shopCategoryName =
        userShopsData?.data?.Shops?.[0]?.shopCategory?.name;
      if (shopCategoryName) {
        localStorage.setItem("mycategory", shopCategoryName);
      }
    }
  }, [userShopsData]);

  const { data: shopQueryData } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopQueryData?.success) {
      setShopData(shopQueryData?.data?.Shop);
    }
  }, [shopQueryData]);

  const [getSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = async () => {
    if (shopData?._id) {
      try {
        const response = await getSuggestions(shopData._id).unwrap();
        setSuggestdata(response?.data?.[0]?.suggestions);
      } catch (error) {
        console.error("Failed to fetch suggestions:", error);
      }
    }
  };

  return (
    <>
      <Container className="restaurant-alldata-page">
        <div className="screenHeight">
          <Col
            xl="11"
            lg="12"
            md="12"
            xs="12"
            sm="12"
            className="restaurant-profile-shell mx-auto rounded p-4 mb-1 mt-3"
            style={{
              boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
              backgroundColor: "#fafafa",
            }}
          >
            <div>
              <RestaurantShopdata
                shopid={id}
                className="images-shopdata"
                shopData={shopData}
                id={id}
                suggestdatta={suggestdatta}
                setSuggest={setSuggest}
              />
            </div>

            <div>
              <RestaurantCard
                id={id}
                suggestdata={suggestdata}
                suggest={suggest}
                setSuggest={setSuggest}
                shopData={shopData}
                shopid={id}
              />
            </div>
          </Col>
        </div>
      </Container>
    </>
  );
};

export default RestaurantAlldata;
